import React from 'react';
import AmplienceFooter, { AmplienceFooterProps } from 'components/amplience/footer';

export interface Props {
  data: AmplienceFooterProps;
}

const Footer: React.FC<Props> = ({ data }) => {
  return (
    <footer className="mx-auto mt-3 w-full bg-primary-lightcream pb-10 lg:pb-0">
      <AmplienceFooter {...data} />
    </footer>
  );
};

export default Footer;
